import CircularProgress from "@mui/material/CircularProgress";
import type { ReactNode } from "react";
import type { SearchDeck } from "src/api/search";
import { Badge } from "src/components/NewComponents/Default/Badge";
import ViewWithPagination from "src/components/NewComponents/Search/ViewWithPagination";

import { DeckCard } from "./DeckCard";

interface DecksSearchGridProps {
	decks: SearchDeck[];
	isLoading: boolean;
	pagesCount: number;
	page: number;
	setPage: (page: number) => void;
	scrollToTop: () => void;
	isSelectMode?: boolean;
	selectedIds?: number[];
	onToggleSelect?: (id: number) => void;
	onToggleList?: (id: number) => void;
	// value → label z availableCategories; badge na karcie.
	categoryLabels?: Record<string, string>;
	// pusta lista wyników
	emptyState: ReactNode;
}

export function DecksSearchGrid({
	decks,
	isLoading,
	pagesCount,
	page,
	setPage,
	scrollToTop,
	isSelectMode,
	selectedIds,
	onToggleSelect,
	onToggleList,
	categoryLabels,
	emptyState,
}: DecksSearchGridProps) {
	if (isLoading) {
		return (
			<div className="flex-center-row w-100 p-64">
				<CircularProgress />
			</div>
		);
	}

	if (!decks.length) {
		return emptyState;
	}

	return (
		<ViewWithPagination
			count={pagesCount}
			page={page}
			setPage={setPage}
			scrollToTop={scrollToTop}
		>
			<div className="deck-search-grid">
				{decks.map((deck) => (
					<DeckCard
						key={deck.code}
						deck={deck}
						badges={
							deck.category && categoryLabels?.[deck.category]
								? [
										<Badge key="category">
											{categoryLabels[deck.category]}
										</Badge>,
									]
								: undefined
						}
						showUsedCount
						isSelectMode={isSelectMode}
						isSelected={selectedIds?.includes(deck.id)}
						onToggleSelect={() => onToggleSelect?.(deck.id)}
						onToggleList={() => onToggleList?.(deck.id)}
					/>
				))}
			</div>
		</ViewWithPagination>
	);
}
